import { ReconMismatchesDetails } from '../../../../containers/Trading/Markets/Recon';
import type { ReconMismatchesDetailsPanelConfig } from '../../../../types/LayoutConfig';
import { Panel } from '../../../Layout/Components/Panel';
import type { LayoutPanelProps } from '../../types';

export function ReconMismatchesDetailsPanel({ api, params }: LayoutPanelProps<ReconMismatchesDetailsPanelConfig>) {
  return (
    <Panel panelApi={api} data-testid="recon-mismatches-details-panel">
      <ReconMismatchesDetails mismatchIDs={params.mismatchIDs} key={api.id} />
    </Panel>
  );
}
